/**
 * T059 — thin dataLayer helper. No network calls. GA4/GTM maps these events.
 */
(function () {
  function push(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  onReady(function () {
    var root = document.documentElement;
    var handle = root.getAttribute('data-product-handle');
    var title = root.getAttribute('data-product-title');
    if (handle) {
      push({
        event: 'pdp_view',
        item_id: handle,
        item_name: title || handle,
      });
    }

    if (document.querySelector('protocol-quiz') || document.querySelector('.protocol-quiz')) {
      push({ event: 'quiz_start', utm_campaign: 'protocol_quiz' });
    }

    document.addEventListener('submit', function (evt) {
      var form = evt.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') !== -1) {
        var plan = form.querySelector('[name="selling_plan"]');
        var idInput = form.querySelector('[name="id"]');
        push({
          event: 'add_to_cart',
          item_id: handle || (idInput && idInput.value) || 'unknown',
          has_selling_plan: !!(plan && plan.value),
        });
      }
    });

    document.addEventListener('click', function (evt) {
      var t = evt.target;
      if (!(t instanceof Element)) return;
      var checkout = t.closest('[name="checkout"], .cart__checkout-button');
      if (checkout) {
        push({
          event: 'begin_checkout',
          item_count: window.Shopify && window.Shopify.cart ? window.Shopify.cart.item_count : undefined,
        });
      }
      var plannerShare = t.closest('[data-planner-share]');
      if (plannerShare) {
        push({
          event: 'planner_share',
          utm_source: 'planner',
          utm_medium: 'referral',
          utm_campaign: 'planner_referral',
          utm_content: plannerShare.getAttribute('data-planner-share') || 'friend',
        });
      }
    });
  });
})();
